module.exports = __webpack_public_path__ + "img/jz-pic4.36c0c1d2.png";